// React
import React from "react";
import PropTypes from "prop-types";

import { TableFilterCell } from "./TableFiltersCells";

import "./TableFilters.css";

TableFilter.propTypes = {
  columns: PropTypes.array,
  filters: PropTypes.array,
  setFilters: PropTypes.func,
  tableArray: PropTypes.array,
  isFilterDisabled: PropTypes.bool,
  // Data for Check All
  filteredData: PropTypes.any,
  isCheckAllAvailable: PropTypes.any,
  checked: PropTypes.any,
  setChecked: PropTypes.any,
};

export default function TableFilter(props) {
  const { columns } = props;
  const { filters, setFilters } = props;
  const { tableArray } = props;
  const { isFilterDisabled } = props;

  // Data for Check All
  const { isCheckAllAvailable } = props;
  const { filteredData } = props;
  const { checked, setChecked } = props;

  if (isFilterDisabled) {
    return null;
  }

  let headings = [];

  const data = {
    filters: filters,
    setFilters: setFilters,
    tableArray: tableArray,
  };

  columns.forEach((cell) => {
    headings.push(
      <TableFilterCell
        key={cell.key}
        cell={cell}
        data={data}
        width={cell.width}
        // Filtered Data for Check All
        filteredData={filteredData}
        isCheckAllAvailable={isCheckAllAvailable}
        // Check Boxes
        checked={checked}
        setChecked={setChecked}
      />
    );
  });

  return <div className="pct-filter-row">{headings}</div>;
}
